import { TableColumn } from 'react-data-table-component';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { Breakpoints } from 'hooks/Screen/useScreenSize';
import { SRBMMonitoringHistoryData } from 'api/traps/SRBMTraps/types';

export const useGetSBSMonitoringHistoryColumns = (): TableColumn<SRBMMonitoringHistoryData>[] => {
  const { t } = useTranslation();

  return [
    // {
    //   name: t('MCTDetail.TrapHistoryCard.dateTime'),
    //   selector: row => row.date_time,
    //   sortable: true,
    //   sortField: 'date_time',
    //   cell: row => dayjs(row.date_time).format('DD-MM-YYYY HH:mm:ss'),
    //   style: { justifyContent: 'center' },
    //   grow: 2,
    // },
    {
      name: t('MCTDetail.TrapHistoryCard.crmDateTime'),
      selector: row => row.crm_date_time,
      sortable: true,
      sortField: 'crm_date_time',
      cell: row => dayjs(row.crm_date_time).format('DD-MM-YYYY HH:mm:ss'),
      style: { justifyContent: 'center' },
      grow: 2,
      hide: Breakpoints.Tablet,
    },
    {
      name: t('MCTDetail.TrapHistoryCard.token'),
      selector: row => row.msg_token,
      hide: Breakpoints.Desktop,
    },
    {
      name: t('MCTDetail.TrapHistoryCard.baitWeight'),
      selector: row => row.bait_filling,
      sortable: true,
      sortField: 'bait_filling',
    },
    {
      name: t('MCTDetail.TrapHistoryCard.rrsi'),
      selector: row => row.rssi,
      sortable: true,
      sortField: 'rssi',
      hide: Breakpoints.Desktop,
    },
    {
      name: t('MCTDetail.TrapHistoryCard.snr'),
      selector: row => row.snr,
      sortable: true,
      sortField: 'snr',
      hide: Breakpoints.Desktop,
    },
    {
      name: t('MCTDetail.TrapHistoryCard.battery'),
      selector: row => row.battery_percentage,
      sortable: true,
      sortField: 'battery_percentage',
      hide: Breakpoints.Mobile,
    },
  ];
};
